import { cn } from "@/lib/cn";

export const Label = ({
  labelTextColor,
  labelBackgroundColor,
  labelBackgroundOpacity,
  label,
  className = "",
}: {
  labelTextColor: string;
  labelBackgroundColor: string;
  labelBackgroundOpacity: number;
  label: string;
  className?: string;
}) => (
  <div
    className={cn(
      "tw-absolute tw-top-2 tw-line-clamp-3 tw-rounded-[3px] tw-px-[6px] tw-py-[3px] tw-text-xs tw-font-semibold [color:var(--text-color)] [font-family:var(--paragraph-form)] after:tw-absolute after:tw-inset-0 after:tw-size-full after:tw-rounded-[3px]  after:tw-bg-[var(--background-color)] after:tw-opacity-[var(--background-opacity)] after:tw-content-['']",
      {
        [className]: !!className,
      },
    )}
    style={
      {
        "--background-color": labelBackgroundColor || "#000000",
        "--background-opacity": `${labelBackgroundOpacity || 80}%`,
        "--text-color": labelTextColor || "#FFFFFF",
      } as React.CSSProperties
    }
  >
    <span className="tw-relative tw-z-1">{label}</span>
  </div>
);
